module.exports = __webpack_public_path__ + "static/img/login-head.19596c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-head.png
// module id = s87k
// module chunks = 1